
<app-notification *ngIf="errorMessage" error="true" locked="true" display="true" timeOut="0" content="{{errorMessage}}"></app-notification>

<div class="uploadfilecontainer" [ngClass]="(hasBorder)?'dashed-border':'border'" [ngStyle]="{'height.px': pixelHeight, 'width': percentWidth + '%'}" (click)="fileInput.click()" appDropzone (onFileDropped)="addFile($event)">
  <input hidden multiple="multiple" type="file" accept="application/pdf" #fileInput (change)="addFile($event.target.files)">
  <div class="dropzone-body is-flex is-align-items-center is-justify-content-center">
    <p [innerHTML]="dropzoneText"></p>
    <img *ngIf="dropzoneImage" [src]="dropzoneImage" alt="Dropzone Image">
  </div>
</div>

<div *ngIf="loadingAlreadyUploadedFiles">
    <ngx-skeleton-loader [theme]="{'animation':'none','margin':'2px auto','width':'80%'}"
                         animation="progress" appearance="line" count="1">
    </ngx-skeleton-loader>
</div>

<div class="files-list" [ngStyle]="{'width': percentWidth + '%'}" *ngFor="let file of files;let i= index">
  <ng-container *ngIf="file.name else emptyFileName">
    <p appTooltip matTooltip="{{file.name}}" class="truncate">{{ file.file?.name }}</p>
    <button class="delete" (click)="deleteAttachment(i)">
    </button>
  </ng-container>

  <ng-template #emptyFileName>
    <p> {{ file.file?.name }}</p>
    <button class="delete" (click)="deleteAttachment(i)">
    </button>
  </ng-template>
</div>
